'use client';

import { BROWSER_FLAG_PREFIX, flagKeyOf, flagParents, type FlagName } from '@poppy/utils';
import { getPosthogClient } from './posthog';

/**
 * Flags turned on locally for testing before they exist in PostHog: NEXT_PUBLIC_POPPY_DEV_FLAGS,
 * comma-separated flag names (enableContentStudio). Never in production; the API app reads
 * POPPY_DEV_FLAGS the same way (apps/poppyai-api lib/features.ts).
 */
const devFlags = new Set(
  process.env.NODE_ENV === 'production'
    ? []
    : (process.env.NEXT_PUBLIC_POPPY_DEV_FLAGS ?? '').split(',').map(flag => flag.trim())
);

const isOwnFlagOn = (key: string) =>
  devFlags.has(key.replace(BROWSER_FLAG_PREFIX, '')) ||
  (getPosthogClient()?.isFeatureEnabled(key) ?? false);

/** Whether a flag from the catalog (@poppy/utils flags) is on, its parents included. */
const isFlagOn = (flag: FlagName) => {
  const key = flagKeyOf(flag);
  return [key, ...flagParents(key)].every(isOwnFlagOn);
};

const flagService = {
  isFlagOn,
};

export default flagService;
